import styled from 'styled-components';

export const AssociarComponent = styled.div.attrs({
    className: `centro-container`
})`


`